import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormlyModule } from '@ngx-formly/core';
import { QuillModule } from 'ngx-quill';
import { BACKEND_URL } from './backend_url';
import { environment } from 'src/environments/environment';
import { AuthInterceptor } from './services/auth/auth.interceptor';
import { InstallationService } from './services/entities/installation.service';
import { getSaver, SAVER } from './utils/reports/saver.provider';
import { routes } from './app.routes';
import {
  FormlyAntIconSelectComponent,
} from './components/custom-field-formly/ant-icon-select/formly-ant-icon-select.component';
import { TariffAutoComplete } from './components/custom-field-formly/tariff-autocomplete.component';
import { RepeatSectionTypeComponent } from './components/custom-field-formly/repeat-section/repeat-section.type';
import { FormlySwitchComponent } from './components/custom-field-formly/switch/formly-switch.component';
import { RepeatComponent } from './components/custom-field-formly/repeat/repeat.component';
import { ICON_PROVIDERS } from './icons-provider';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DatePickerComponent } from './components/date-picker/date-picker.component';

let backendUrl = BACKEND_URL;
if (backendUrl.startsWith('$')) backendUrl = environment.backendUrl;
const sessionsBackendUrl = environment.sessionsApiUrl || backendUrl;

console.log('BACKEND URL', backendUrl);
console.log('SESSIONS BACKEND URL', sessionsBackendUrl);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService(),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    importProvidersFrom(
      QuillModule.forRoot(),
      NzModalModule,
      FormlyModule.forRoot({
        types: [
          { name: 'nz-autocomplete-tariff', component: TariffAutoComplete },
          { name: 'repeat-section', component: RepeatSectionTypeComponent },
          { name: 'switch', component: FormlySwitchComponent },
          { name: 'date-picker', component: DatePickerComponent },
          { name: 'repeat', component: RepeatComponent },
          { name: 'formly-ant-icon-select', component: FormlyAntIconSelectComponent },
        ],
      }),
    ),
    { provide: 'BACKEND_URL', useValue: backendUrl },
    { provide: 'SESSIONS_BACKEND_URL', useValue: sessionsBackendUrl },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: 'SOCKET_IO_ADDRESS', useValue: backendUrl },
    InstallationService,
    { provide: SAVER, useFactory: getSaver },
    ...ICON_PROVIDERS,
  ],
};
